// src/lib/supabase.js — extracted from App.js
import { createClient } from "@supabase/supabase-js";
import { SUPABASE_URL, SUPABASE_ANON_KEY } from "../constants";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export async function loadDB(table) {
  try {
    const { data, error } = await supabase.from(table).select("*");
    if (error) throw error;
    return data || [];
  } catch { return []; }
}

export async function syncDB(table, rows) {
  try {
    if (rows.length > 0) {
      const { error } = await supabase.from(table).upsert(rows);
      if (error) console.error("syncDB error", table, error.message, error.code);
    }
  } catch (e) { console.error("syncDB network error", table, e); }
}

export async function deleteFromDB(table, id) {
  try {
    const { error } = await supabase.from(table).delete().eq("id", id);
    if (error) console.error("deleteFromDB error", table, id, error.message);
  } catch (e) { console.error("deleteFromDB network error", table, e); }
}

// Targeted single-record write — throws on failure so callers can surface the error
export async function upsertOne(table, patch) {
  const { error } = await supabase.from(table).upsert(patch, { onConflict: "id" });
  if (error) throw new Error(error.message);
}
